export var AssistantStatus;
(function (AssistantStatus) {
    AssistantStatus["IDLE"] = "idle";
    AssistantStatus["PROCESSING"] = "assistant.processing_input";
    AssistantStatus["THINKING"] = "assistant.thinking";
    AssistantStatus["TOOL_EXECUTING"] = "assistant.tool_executing";
    AssistantStatus["RESPONDING"] = "assistant.responding";
    AssistantStatus["COMPLETE"] = "assistant.complete";
    AssistantStatus["ERROR"] = "assistant.error";
})(AssistantStatus || (AssistantStatus = {}));
export const AssistantTranslationKeys = {
    Thinking: 'assistant.thinking',
    ToolExecuting: 'assistant.tool_executing',
    ToolResult: 'assistant.tool_result',
    ToolNotFound: 'assistant.tool_not_found',
    ToolExecutionError: 'assistant.tool_execution_error',
    Complete: 'assistant.complete',
    Error: 'assistant.error',
    ProcessingInput: 'assistant.processing_input',
    ToolSearchGrantsStart: 'assistant.tool_search_grants_start',
    ToolSearchGrantsMapping: 'assistant.tool_search_grants_mapping',
    ToolSearchGrantsQuerying: 'assistant.tool_search_grants_querying',
    ToolSearchGrantsCounting: 'assistant.tool_search_grants_counting',
    ToolSearchGrantsSuccessN: 'assistant.tool_search_grants_success_n',
    ToolSearchGrantsQueryError: 'assistant.tool_search_grants_query_error',
    ToolSearchGrantsMarshalError: 'assistant.tool_search_grants_marshal_error',
    ToolSearchGrantsNoResults: 'assistant.tool_search_grants_no_results',
    ToolSearchGrantsFoundN: 'assistant.tool_search_grants_found_n',
    ToolSearchGrantsEnriching: 'assistant.tool_search_grants_enriching',
    ToolWebSearchStart: 'assistant.tool_web_search_start',
    ToolWebSearchSearching: 'assistant.tool_web_search_searching',
    ToolWebSearchSuccess: 'assistant.tool_web_search_success',
    ToolWebSearchError: 'assistant.tool_web_search_error',
    ToolWebSearchNoResults: 'assistant.tool_web_search_no_results',
    ToolWebSearchCard: 'assistant.tool_web_search_card',
    ToolTestStart: 'assistant.tool_test_start',
    ToolTestProcessing: 'assistant.tool_test_processing',
    ErrorToolNotFound: 'assistant.error_tool_not_found',
    ErrorToolValidationFailed: 'assistant.error_tool_validation_failed',
    ErrorToolExecutionFailed: 'assistant.error_tool_execution_failed',
    ErrorFailedToLoadHistory: 'assistant.error_failed_to_load_history',
    ErrorInvalidRequest: 'assistant.error_invalid_request',
    ErrorGenericFailure: 'assistant.error_generic_failure',
    TurnInProgress: 'assistant.turn_in_progress',
    ContinuationNotAllowed: 'assistant.continuation_not_allowed',
    ErrorSaveUserMessage: 'assistant.error_save_user_message',
    ErrorRetrieveHistory: 'assistant.error_retrieve_history',
    ErrorSaveAssistantMessage: 'assistant.error_save_assistant_message',
};
export const ERROR_STATUS_KEYS = [
    AssistantTranslationKeys.ErrorToolNotFound,
    AssistantTranslationKeys.ErrorToolValidationFailed,
    AssistantTranslationKeys.ErrorToolExecutionFailed,
];
export const isErrorStatusKey = (k) => k ? ERROR_STATUS_KEYS.includes(k) : false;
export const STATUS_TEXT_MAP = {
    [AssistantTranslationKeys.Thinking]: 'Thinking…',
    [AssistantTranslationKeys.ToolExecuting]: 'Executing tool…',
    [AssistantTranslationKeys.ToolResult]: 'Processing tool result…',
    [AssistantTranslationKeys.ProcessingInput]: 'Processing input…',
    [AssistantTranslationKeys.Complete]: 'Complete',
    [AssistantTranslationKeys.Error]: 'An error occurred',
    [AssistantTranslationKeys.ToolSearchGrantsMapping]: 'Mapping search criteria…',
    [AssistantTranslationKeys.ToolSearchGrantsQuerying]: 'Querying grant database…',
    [AssistantTranslationKeys.ToolSearchGrantsCounting]: 'Counting results…',
    [AssistantTranslationKeys.ToolSearchGrantsEnriching]: 'Enriching grant data…',
    [AssistantTranslationKeys.ToolSearchGrantsSuccessN]: 'Grant search completed',
    [AssistantTranslationKeys.ToolSearchGrantsQueryError]: 'Grant search query error',
    [AssistantTranslationKeys.ToolWebSearchSearching]: 'Searching the web…',
    [AssistantTranslationKeys.ToolWebSearchSuccess]: 'Web search completed',
    [AssistantTranslationKeys.ToolWebSearchError]: 'Web search error',
    [AssistantTranslationKeys.ErrorToolNotFound]: 'Tool not found',
    [AssistantTranslationKeys.ErrorToolValidationFailed]: 'Tool validation failed',
    [AssistantTranslationKeys.ErrorToolExecutionFailed]: 'Tool execution failed',
    [AssistantTranslationKeys.ToolNotFound]: '',
    [AssistantTranslationKeys.ToolExecutionError]: '',
    [AssistantTranslationKeys.ToolSearchGrantsStart]: '',
    [AssistantTranslationKeys.ToolSearchGrantsMarshalError]: '',
    [AssistantTranslationKeys.ToolSearchGrantsNoResults]: '',
    [AssistantTranslationKeys.ToolSearchGrantsFoundN]: '',
    [AssistantTranslationKeys.ToolWebSearchStart]: '',
    [AssistantTranslationKeys.ToolWebSearchNoResults]: '',
    [AssistantTranslationKeys.ToolWebSearchCard]: '',
    [AssistantTranslationKeys.ToolTestStart]: '',
    [AssistantTranslationKeys.ToolTestProcessing]: '',
    [AssistantTranslationKeys.ErrorFailedToLoadHistory]: '',
    [AssistantTranslationKeys.ErrorInvalidRequest]: '',
    [AssistantTranslationKeys.ErrorGenericFailure]: '',
    [AssistantTranslationKeys.TurnInProgress]: '',
    [AssistantTranslationKeys.ContinuationNotAllowed]: '',
    [AssistantTranslationKeys.ErrorSaveUserMessage]: '',
    [AssistantTranslationKeys.ErrorRetrieveHistory]: '',
    [AssistantTranslationKeys.ErrorSaveAssistantMessage]: '',
};
export const getStatusText = (key, extraContent) => {
    var _a;
    if (key === AssistantTranslationKeys.ToolSearchGrantsCounting &&
        extraContent) {
        return `Found ${extraContent} grants`;
    }
    return (_a = STATUS_TEXT_MAP[key]) !== null && _a !== void 0 ? _a : key;
};
export const AVAILABLE_MODELS = {
    CLAUDE_OPUS_4_8: 'claude-opus-4-8',
    CLAUDE_OPUS_4_6: 'claude-opus-4-6',
    CLAUDE_OPUS_4_5: 'claude-opus-4-5',
    GPT_5_5: 'gpt-5.5',
    GPT_5_4: 'gpt-5.4',
    GPT_5_4_MINI: 'gpt-5.4-mini',
    GPT_5_2: 'gpt-5.2',
    GPT_5_1: 'gpt-5.1',
    GPT_5: 'gpt-5',
    CLAUDE_4_5_SONNET: 'claude-sonnet-4-5',
    CLAUDE_SONNET_4_0: 'claude-sonnet-4-0',
};
export const MODEL_OPTIONS = [
    {
        value: AVAILABLE_MODELS.CLAUDE_OPUS_4_8,
        label: 'Claude Opus 4.8',
        description: 'Top-tier Claude model with a 1M-token context window',
    },
    {
        value: AVAILABLE_MODELS.CLAUDE_OPUS_4_6,
        label: 'Claude Opus 4.6',
        description: 'Top-tier model for the most demanding tasks',
    },
    {
        value: AVAILABLE_MODELS.GPT_5_5,
        label: 'GPT-5.5',
        description: 'New OpenAI model for coding and professional work',
    },
];
export const ALL_MODEL_LABELS = {
    [AVAILABLE_MODELS.CLAUDE_OPUS_4_8]: 'Claude Opus 4.8',
    [AVAILABLE_MODELS.CLAUDE_OPUS_4_6]: 'Claude Opus 4.6',
    [AVAILABLE_MODELS.CLAUDE_OPUS_4_5]: 'Claude Opus 4.5',
    [AVAILABLE_MODELS.GPT_5_5]: 'GPT-5.5',
    [AVAILABLE_MODELS.GPT_5_4]: 'GPT-5.4',
    [AVAILABLE_MODELS.GPT_5_4_MINI]: 'GPT-5.4 mini',
    [AVAILABLE_MODELS.GPT_5_2]: 'GPT-5.2',
    [AVAILABLE_MODELS.GPT_5_1]: 'GPT-5.1',
    [AVAILABLE_MODELS.GPT_5]: 'GPT-5',
    [AVAILABLE_MODELS.CLAUDE_4_5_SONNET]: 'Claude Sonnet 4.5',
    [AVAILABLE_MODELS.CLAUDE_SONNET_4_0]: 'Claude Sonnet 4',
};
export const DEFAULT_ADMIN_MODEL = AVAILABLE_MODELS.CLAUDE_OPUS_4_8;
export const DEFAULT_CLIENT_MODEL = AVAILABLE_MODELS.CLAUDE_OPUS_4_8;
export const getDefaultModel = (app) => {
    return app === 'client' ? DEFAULT_CLIENT_MODEL : DEFAULT_ADMIN_MODEL;
};
export const AGENT_MODE_OPTIONS = [
    {
        value: null,
        labelKey: 'assistant|agent_mode_none_label',
        descriptionKey: 'assistant|agent_mode_none_description',
    },
    {
        value: 'writing',
        labelKey: 'assistant|agent_mode_writing_label',
        descriptionKey: 'assistant|agent_mode_writing_description',
    },
    {
        value: 'review',
        labelKey: 'assistant|agent_mode_review_label',
        descriptionKey: 'assistant|agent_mode_review_description',
    },
];
export const ASSISTANT_EMBEDDED_CONVERSATION_PARAM = 'assistantConversationId';
export const ASSISTANT_DISPLAY_NAME = 'Charles Darwin';
